import {
  ContentSearchAPIResponse,
  ContentSearchItemAPIResponse,
  ContentSearchQueryData,
} from '../types';

export const CONTENT_SEARCH_PAGE_SIZE = 30;
export const LIBRARY_PAGE_SIZE = 15;

/** API omits empty arrays instead of returning []. */
export const normalizeContentSearchResponse = (
  response: Partial<ContentSearchAPIResponse>,
): ContentSearchAPIResponse => ({
  care_programs: response.care_programs ?? [],
  on_demand: response.on_demand ?? [],
});

/**
 * True if this list's current page is full; more pages may exist for it.
 * care_programs and on_demand have different total counts, so this is checked per-list.
 * TODO(WFMOB-15624): use pagination.has_next_page once available.
 */
export const hasMoreResults = (
  items: ContentSearchItemAPIResponse[],
  pageSize: number = CONTENT_SEARCH_PAGE_SIZE,
): boolean => items.length >= pageSize;

/** Replace on page 0, append otherwise. */
export const mergeContentSearchResults = (
  currentCache: ContentSearchQueryData,
  newItems: ContentSearchQueryData,
  page: number,
): ContentSearchQueryData =>
  page === 0
    ? newItems
    : {
        care_programs: [...currentCache.care_programs, ...newItems.care_programs],
        on_demand: [...currentCache.on_demand, ...newItems.on_demand],
        careProgramsHasMore: newItems.careProgramsHasMore,
        onDemandHasMore: newItems.onDemandHasMore,
      };
